var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',[_vm._t("default"),_vm._v(" "),(_vm.component)?_c('div',{staticClass:"col-12 col-lg-2"},[_c(_vm.component.name,_vm._b({tag:"Component",attrs:{"component":_vm.component}},'Component',_vm.component.options,false))],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }